import { Link, usePage } from "@inertiajs/react"

import AppLogoIcon from "@/components/app-logo-icon"
import { Button } from "@/components/ui/button"
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu"
import { rootPath, signInPath, signUpPath, pricingPath } from "@/routes"

export default function LandingNavbar() {
  const page = usePage()
  const { auth } = page.props

  // Only render when user is NOT signed in
  if (auth.user) {
    return null
  }

  return (
    <nav className="border-b border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-950">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        {/* Logo and Pricing */}
        <div className="flex items-center gap-6">
          <Link href={rootPath()} className="flex items-center">
            <AppLogoIcon className="h-8 w-auto" />
          </Link>
          <Link href={pricingPath()}>
            <Button variant="ghost" className="text-neutral-900 dark:text-neutral-100">
              Pricing
            </Button>
          </Link>
        </div>

        {/* Sign In and Sign Up */}
        <div className="flex items-center gap-2">
          <Link href={signInPath()}>
            <Button variant="ghost" className="text-neutral-900 dark:text-neutral-100">
              Sign In
            </Button>
          </Link>
          <Link href={signUpPath()}>
            <Button className="bg-neutral-900 text-white hover:bg-neutral-800 dark:bg-neutral-100 dark:text-neutral-900 dark:hover:bg-neutral-200">
              Sign Up
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  )
}

